import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AlertModalState, openAlertModal } from '../store/alert-modal';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    constructor(
        private alertModalState: Store<AlertModalState>
    ) { }

    /**
     * 開啟警告視窗
     * @param message `string` 顯示內容
     */
    openAlert(message: string) {
        this.alertModalState.dispatch(openAlertModal({message: message}))
    }
}
